"use client";

import { useState } from "react";
import { PasswordSignInForm } from "./PasswordSignInForm";
import { MagicLinkSignInForm } from "./MagicLinkSignInForm";
type SignInFormProps = {
  redirectPath?: string;
};
export default function SignInForm({
  redirectPath
}: SignInFormProps) {
  const [useMagicLink, setUseMagicLink] = useState(false);
  return <div className={"flex flex-col gap-6"} data-sentry-component="SignInForm" data-sentry-source-file="signin-form.tsx">
      {useMagicLink ? <MagicLinkSignInForm redirectPath={redirectPath} onSwitchToPassword={() => setUseMagicLink(false)} /> : <PasswordSignInForm redirectPath={redirectPath} onSwitchToMagicLink={() => setUseMagicLink(true)} />}
    </div>;
}